module.exports = __webpack_public_path__ + "fonts/dm-sans-v6-latin-regular.ad51351.woff2";